import React from 'react';
import { Routes,Route } from 'react-router-dom';
import { BrowserRouter } from "react-router-dom";


import Allmeasures from './pages/allmeasurespage/AllmeasuresPage';
import Homepage from './pages/homepage/HomePage'
import Infopage from './pages/infopage/InfoPage'
import './App.css';

import "../src/assets/fonts/DaimlerCS-Regular.woff2";
import "../src/assets/fonts/DaimlerCS-Demi.woff2";


function App() {

  return (
    <div className="App">
    <BrowserRouter>
    <Routes>
    <Route path="/" element={<Homepage/>}/>
      <Route path="/allmeasures" element={<Allmeasures/>}/>
      <Route path="/info/:type" element={<Infopage/>}/>
    </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
